/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect, useCallback } from "react";
import "./remediationDocumentStyles.css";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getTestListAction,
  handleAddRowAction,
  updateHeaderInfoDrag,
  handleRowDeleteAction,
  handleAllSelectionAction,
  handleRowSelectionAction,
  handleAllRowDeleteAction,
  getRemediationDataAction,
  refreshRemediationtDataAction,
  handleRowStatusAction,
  fetchLabResultsAction,
} from "store/actions/remediation_priorities_document/remediationPrioritiesDocumentAction";
import { profileRequest } from "services/auth-service";
import ActionButton from "./ActionButton/ActionButton";
import ReportHeaderInfo from "./ReportHeaderInfo/ReportHeaderInfo";
import Tires from "./Tires/Tires";
import { Typography } from "@mui/material";
import { Fullscreen, FullscreenExit } from "@mui/icons-material";
import CustomTable from "main/components/Customtable/CustomTable";
import {
  getColumnsOfAmbientTable,
  getColumnsOfHvacTable,
  getColumnsOfRemediationTable,
  TestResultsTable,
} from "./utility/helper";
import ConfirmationModal from "main/components/ConfirmationModal/ConfirmationModal";
import MainFilters from "./MainFilters/MainFilters";
import { Button } from "react-bootstrap";
import { showToast } from "main/shared/helpers";
import { SET_SIDENAV } from "store/actions";
import CloseIcon from "assets/icons/closeButton.svg";
import LeftCloseBarIcon from "assets/icons/leftCloseBarIcon.svg";
import AIAssistantDrawer from "./AIAssistantDrawer/AIAssistantDrawer";

let approveBtnDisabled = true;

const tableConfigs = [
  {
    key: "remediation_report",
    className: "sample_table_container",
    getColumns: getColumnsOfRemediationTable,
  },
  {
    key: "hvac",
    className: "hvac_table",
    getColumns: getColumnsOfHvacTable,
  },
  {
    key: "ambient",
    className: "ambient_table",
    getColumns: getColumnsOfAmbientTable,
  },
];

const filtersData = [
  {
    id: 1,
    label: "All",
    value: "all",
  },
  {
    id: 2,
    label: "Approved",
    value: "approved",
  },
  {
    id: 3,
    label: "Unapproved",
    value: "unapproved",
  },
];

const RemidiationPrioritiesDocument = () => {
  const { insp_id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const remediationPrioritiesDocument = useSelector(
    (state) => state.remediationPrioritiesDocument
  );

  const sidenavCollapsed = useSelector((state) => state.sidenav.collapsed);

  const {
    testList,
    testListLoading,
    getRemediationLoading,
    reportData,
    saveRemediationDataLoading,
    publishRemediationDataLoading,
    refreshRemediationDataLoading,
  } = remediationPrioritiesDocument;

  const {
    tier,
    prioritizing_section,
    order_event,
    cat_of_water,
    category_water,
  } = reportData;

  const [mainFilters, setMainFilters] = useState("all");
  const [testResultsOpen, setTestResultsOpen] = useState(false);
  const [selectedTestResult, setSelectedTestResult] = useState(null);
  const [aiDrawerOpen, setAiDrawerOpen] = useState(false);
  const [selectedAiRow, setSelectedAiRow] = useState(null);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [selectedTier, setSelectedTier] = useState({});
  const [filteredData, setFilteredData] = useState({});
  // const [selectAllRows, setSelectAllRows] = useState({});
  const [newRowsAddedData, setNewRowsAddedData] = useState({
    remediation_report: [],
    hvac: [],
    ambient: [],
  });
  const [hasUnapprovedItems, setHasUnapprovedItems] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState({});
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [labResultsFetched, setLabResultsFetched] = useState(false);
  const testListOptions = JSON.parse(JSON.stringify(testList)) || [];

  const isSampleStrategyReportShown = async () => {
    try {
      const res = await profileRequest();
      const { show_sample_strategy } = res.data;
      return show_sample_strategy;
    } catch (err) {
      console.error(err.response);
      return false;
    }
  };

  const isLoading = () => {
    return testListLoading || getRemediationLoading;
  };

  const handleSelectRow = (row, tableKey) => {
    dispatch(handleRowSelectionAction(row, tableKey));
  };

  const handleAllSelectRow = (e, tableKey) => {
    dispatch(handleAllSelectionAction(e, tableKey));
  };

  const handleStatusRow = (row, tableKey) => {
    setHasUnapprovedItems(row.status);
    dispatch(handleRowStatusAction(row, tableKey));
  };

  const handleAddRow = (tableKey) => {
    setHasUnapprovedItems(true);
    dispatch(handleAddRowAction(tableKey, setNewRowsAddedData));
  };

  const handleDeleteRow = (row, tableKey) => {
    dispatch(handleRowDeleteAction(row, tableKey, setNewRowsAddedData));
  };

  const handleAllDeleteRow = () => {
    dispatch(handleAllRowDeleteAction(setHasUnapprovedItems));
  };

  const handleRefresh = async () => {
    try {
      await dispatch(refreshRemediationtDataAction(insp_id));
      setLabResultsFetched(false); // Reset flag so lab results can be fetched again
      showToast("Data Refreshed Successfully", true);
    } catch (e) {
      console.log(e);
      showToast(e?.message);
    }
  };
  let currentColor = "row-white";

  const addClassToRow = (params) => {
    const { api, node, data } = params;
    const currentRoomName = data?.room_name?.name || "";
    const currentIndex = node.rowIndex;

    if (currentIndex === 0) {
      currentColor = "row-white"; // first row always white
      return currentColor;
    }

    const previousNode = api.getDisplayedRowAtIndex(currentIndex - 1);
    if (!previousNode) {
      return currentColor;
    }

    const previousRoomName = previousNode.data?.room_name?.name || "";

    if (currentRoomName === previousRoomName) {
      return currentColor;
    } else {
      currentColor = currentColor === "row-white" ? "row-gray" : "row-white";
      return currentColor;
    }
  };

  useEffect(() => {
    const checkSampleStrategy = async () => {
      const result = await isSampleStrategyReportShown();
      if (!result) {
        navigate(-1);
      }
    };
    checkSampleStrategy();
  }, [navigate]);

  useEffect(() => {
    const getTestList = async () => {
      try {
        dispatch(getTestListAction());
      } catch (error) {
        console.log("error", error);
      }
    };

    const getRemediationData = async () => {
      try {
        const data = await dispatch(getRemediationDataAction(insp_id));
        setLabResultsFetched(false); // Reset flag when fetching new data
        // Fetch lab results immediately after remediation data is loaded
        if (data?.remediation_report?.data?.length) {
          // Pass the data directly to avoid state timing issues
          dispatch(fetchLabResultsAction(insp_id, data));
          setLabResultsFetched(true);
        }
      } catch (error) {
        console.log("error", error);
      }
    };

    getTestList();
    getRemediationData();
  }, [dispatch, insp_id]);

  // Fetch lab results after reportData is loaded (only once) - fallback
  useEffect(() => {
    if (
      reportData?.remediation_report?.data?.length &&
      !getRemediationLoading &&
      !labResultsFetched
    ) {
      dispatch(fetchLabResultsAction(insp_id));
      setLabResultsFetched(true);
    }
  }, [
    reportData?.remediation_report?.data,
    getRemediationLoading,
    dispatch,
    insp_id,
    labResultsFetched,
  ]);

  const dbUpdateLoading = () => {
    return (
      getRemediationLoading ||
      saveRemediationDataLoading ||
      publishRemediationDataLoading ||
      refreshRemediationDataLoading
    );
  };

  const handleHeaderInfo = (id, sample_rows, table) => {
    dispatch(updateHeaderInfoDrag(id, sample_rows, table));
  };

  const handleToggleSidebar = (rowData = null) => {
    // Only collapse the sidebar, don't toggle - just set it to collapsed if not already collapsed
    if (!sidenavCollapsed) {
      dispatch({ type: SET_SIDENAV, payload: { collapsed: true } });
    }
    if (rowData?.result_data) {
      setAiDrawerOpen(false);
      setSelectedAiRow(null);
      setSelectedTestResult(rowData);
      setTestResultsOpen(true);
    } else {
      setTestResultsOpen(false);
      setSelectedTestResult(null);
      setIsFullscreen(false);
    }
  };

  const handleToggleAiDrawer = (rowData = null) => {
    if (!sidenavCollapsed) {
      dispatch({ type: SET_SIDENAV, payload: { collapsed: true } });
    }

    if (rowData) {
      setTestResultsOpen(false);
      setSelectedTestResult(null);
      setIsFullscreen(false);
      setSelectedAiRow(rowData);
      setAiDrawerOpen(true);
    } else {
      setAiDrawerOpen(false);
      setSelectedAiRow(null);
    }
  };

  const handleToggleFullscreen = () => {
    setIsFullscreen(!isFullscreen);
  };

  const filterTableData = useCallback(
    (tableKey, data) => {
      const selectedOptionsMap = selectedOptions[tableKey] || [];
      const selectedTierMap = selectedTier[tableKey] || [];

      const hasUnapproved = data.some((row) => row?.status === false);
      setHasUnapprovedItems((prev) => prev || hasUnapproved);

      const shouldFilter =
        selectedOptionsMap.length > 0 ||
        selectedTierMap.length > 0 ||
        mainFilters !== "all";

      if (!shouldFilter) {
        setFilteredData((prev) => {
          const { [tableKey]: _, ...rest } = prev;
          return rest;
        });

        return;
      }

      const filteredRows = (data || []).filter((row) => {
        const hasSelectedOption =
          selectedOptionsMap.length === 0 ||
          selectedOptionsMap.includes(row?.test?.name);
        const hasSelectedTier =
          selectedTierMap.length === 0 || selectedTierMap.includes(row?.tier);

        const matchesMainFilter =
          mainFilters === "all" ||
          (mainFilters === "approved" && row?.status === true) ||
          (mainFilters === "unapproved" && row?.status === false);

        return hasSelectedOption && hasSelectedTier && matchesMainFilter;
      });

      setFilteredData((prev) => ({ ...prev, [tableKey]: filteredRows }));
    },
    [selectedOptions, selectedTier, mainFilters]
  );

  useEffect(() => {
    if (!reportData) return;
    tableConfigs.forEach(({ key }) => {
      const data = reportData[key]?.data || [];
      approveBtnDisabled = data.some((r) => r.client_approval === false);
      // const allSelected =
      //   data.length > 0 && data.every((r) => r.status === true);
      // setSelectAllRows((prev) => ({ ...prev, [key]: allSelected }));

      filterTableData(key, data);
    });
  }, [reportData, filterTableData, mainFilters]);

  // Restore sidebar to full width when component unmounts (user leaves route)
  useEffect(() => {
    return () => {
      // Cleanup: restore sidebar when leaving the route
      dispatch({ type: SET_SIDENAV, payload: { collapsed: false } });
    };
  }, [dispatch]);

  return (
    <div
      className={`remidiationCnt ${testResultsOpen || aiDrawerOpen ? `drawer-open ${testResultsOpen ? "test-results-open" : "ai-drawer-open"} ${isFullscreen ? "remidiationCnt-fullscreen" : ""}` : ""}`}
    >
      {isLoading() ? (
        <div className="loader_container">
          <div className="styles.loader"></div>
        </div>
      ) : (
        <div className="report_container">
          {dbUpdateLoading() ? (
            <div className="loader_overlay">
              <div className="loader"></div>
            </div>
          ) : (
            <></>
          )}
          <div className="remidiationInnerCnt main-content-wrapper">
            <ActionButton
              selectedFilters={mainFilters}
              testResultsOpen={testResultsOpen}
            />
            <ReportHeaderInfo />

            <div className="prioritizing_section">
              <Typography variant="h4">
                {prioritizing_section?.heading}
              </Typography>
              <div
                className="html_content"
                dangerouslySetInnerHTML={{ __html: prioritizing_section?.body }}
              />
            </div>

            <div className="tiresCnt">
              <Tires tier={tier} />
            </div>

            <div className="filtersCnt">
              <MainFilters
                data={filtersData}
                mainFilters={mainFilters}
                setMainFilters={setMainFilters}
                approveStatus={approveBtnDisabled}
                hasUnapprovedItems={hasUnapprovedItems}
                setShowConfirmation={setShowConfirmation}
              />
            </div>

            {tableConfigs.map(({ key, className, getColumns }) => {
              const tableData = reportData?.[key]?.data;

              return (
                <div key={key} className={className}>
                  <CustomTable
                    columns={getColumns({
                      tableKey: key,
                      tiers: { tier },
                      testListOptions,
                      selectedTier,
                      setSelectedTier,
                      selectedOptions,
                      setSelectedOptions,
                      //selectAllRows: selectAllRows,
                      handleStatusRow: handleStatusRow,
                      handleSelectRow: handleSelectRow,
                      handleAllSelectRow: handleAllSelectRow,
                      handleDeleteRow: setShowConfirmation,
                      handleHeaderInfo: handleHeaderInfo,
                      handleToggleSidebar: handleToggleSidebar,
                      handleToggleAiDrawer: handleToggleAiDrawer,
                      data: tableData,
                    })}
                    tableKey={key}
                    data={tableData}
                    showAddBtn={true}
                    addClass={addClassToRow}
                    handleAddRow={handleAddRow}
                    newRowsAddedData={newRowsAddedData[key]}
                    handleHeaderInfo={handleHeaderInfo}
                    filteredData={filteredData[key] || tableData}
                  />
                </div>
              );
            })}

            <div className="order_of_event">
              <Typography variant="h4">{order_event?.title}</Typography>
              <div
                className="html_content"
                dangerouslySetInnerHTML={{ __html: order_event?.body }}
              />
            </div>
            <div className="cat_of_water">
              <Typography variant="h4">{cat_of_water?.title}</Typography>
              <div
                className="html_content"
                dangerouslySetInnerHTML={{ __html: cat_of_water?.body }}
              />
            </div>
            <div className="categorites_of_water">
              <Typography variant="h4">{category_water?.title}</Typography>
              <div
                className="html_content"
                dangerouslySetInnerHTML={{ __html: category_water?.body }}
              />
            </div>
            <div className="remediationFooter">
              <div className="refreshBtnCnt">
                <Button
                  onClick={() => setShowConfirmation({ refresh: true })}
                  className="refreshBtn"
                  // size="sm"
                >
                  <img
                    src={require("../../../assets/icons/Refresh.png")}
                    alt="Refresh"
                  />
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
      {testResultsOpen && selectedTestResult && (
        <div
          className={`test-results-panel ${isFullscreen ? "fullscreen" : ""}`}
        >
          <img
            src={LeftCloseBarIcon}
            className="test-results-close-btn"
            onClick={() => {
              setTestResultsOpen(false);
              setSelectedTestResult(null);
              setIsFullscreen(false);
              setAiDrawerOpen(false);
              setSelectedAiRow(null);
              dispatch({ type: SET_SIDENAV, payload: { collapsed: false } });
            }}
          />
          <div className="test-results-header">
            <h3>Test Result</h3>
            <div className="test-results-header-actions">
              {isFullscreen ? (
                <FullscreenExit
                  fontSize="large"
                  className="fullscreen-toggle-btn"
                  onClick={handleToggleFullscreen}
                  title="Exit fullscreen"
                  style={{ cursor: "pointer" }}
                />
              ) : (
                <Fullscreen
                  fontSize="large"
                  className="fullscreen-toggle-btn"
                  onClick={handleToggleFullscreen}
                  title="Enter fullscreen"
                  style={{ cursor: "pointer" }}
                />
              )}
              <img
                src={CloseIcon}
                className="close-test-results"
                onClick={() => {
                  setTestResultsOpen(false);
                  setSelectedTestResult(null);
                  setIsFullscreen(false);
                  setAiDrawerOpen(false);
                  setSelectedAiRow(null);
                  dispatch({
                    type: SET_SIDENAV,
                    payload: { collapsed: false },
                  });
                }}
              />
            </div>
          </div>
          <div className="test-results-content">
            <TestResultsTable
              resultData={selectedTestResult}
              outsideRoom={reportData?.outsideRoom}
              allRows={reportData?.remediation_report?.data}
            />
          </div>
        </div>
      )}
      {aiDrawerOpen && selectedAiRow && (
        <AIAssistantDrawer
          selectedAiRow={selectedAiRow}
          onClose={() => {
            setAiDrawerOpen(false);
            setSelectedAiRow(null);
            dispatch({ type: SET_SIDENAV, payload: { collapsed: false } });
          }}
        />
      )}
      <ConfirmationModal
        show={showConfirmation}
        onHide={() => setShowConfirmation(false)}
        msg={
          showConfirmation?.refresh
            ? "Refreshing this document will discard all changes and revert it to its original state. Are you sure you want to refresh this document?"
            : showConfirmation?.all
              ? "Are you sure you want to delete all unapproved samples?"
              : "Are you sure you want to delete this sample?"
        }
        onDelete={() =>
          showConfirmation?.refresh
            ? handleRefresh()
            : showConfirmation.all
              ? handleAllDeleteRow()
              : handleDeleteRow(showConfirmation.row, showConfirmation.tableKey)
        }
        yesBtnText={showConfirmation?.refresh ? "Refresh" : "Delete"}
        noBtnText={"Cancel"}
        noBtnStyle
        hideOnPress
      />
    </div>
  );
};

export default RemidiationPrioritiesDocument;
